import CustomCard from '../../../../../components/CustomCard';
import CustomTabContainer from '../../../../../components/CustomTabContainer';
import CustomTab from '../../../../../components/CustomTab';
import React from 'react';
import { TABS_USER_TYPE } from '../Model/Models';
import AttendeesTypesApp from '../Functionality/AttendeesTypesApp';
import AttendingUsersTable from '../AttendingUsersTable';
import UserCardDetails from '../Components/UserCardDetails';
import SectionSelected from '../Components/SectionSelected';
import NotInformation from '../../../../../components/NotInformation';
import CustomUserChip from '../../../../../components/CustomUserChip';
import { CleanIcon, CloseIcon, InfoChip } from '../../../../../components/buttons/IconButtons';
import { POSITION_MODEL } from '../../../../../Helpers/PositionModel';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import { Trans } from 'react-i18next';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const AttendeesTypes = (props) => {
    const { usersSelected, setUsersSelected, eventDetail, handleClearSteps } = props;

    const {
        t,
        selectedUserType, setSelectedUserType,
        setBodyForExport,
        searchElement, setSearchElement,
        setSearch,
        setSimpleSearch,
        results, setResults,
        optionTable,
        showCreateNewVisitorModal, setShowCreateNewVisitorModal,
        modified, setModified,
        getEventSetting
    } = AttendeesTypesApp();

    return (
        <>
            {(eventDetail.id === null || eventDetail.id === '') && (
                <div className='col-12 d-flex justify-content-end mb-2'>
                    <ButtonIcon
                        className='btn-clean-secondary-600'
                        id='btn_rd_clean_form'
                        Icon={CleanIcon}
                        title={'clear_instances'}
                        onClick={() => {
                            setSearchElement("");
                            setResults(prev => ({
                                ...prev,
                                content: [],
                                empty: true,
                                numberOfElements: 0,
                                totalElements: 0,
                                totalPages: 0
                            }));
                            setSelectedUserType(TABS_USER_TYPE[0].key)
                            handleClearSteps();
                        }}
                    />
                </div>
            )}

            { getEventSetting?.attendeesLimitsEnabled &&
                <div className="mb-3">
                    <CustomUserChip
                        className="m-0 chip-secondary-150-100 w-100 p-0 justify-content-start"
                        name={
                            <Trans
                                i18nKey="maximum_value_attendees_per_reservation"
                                values={{ value: getEventSetting?.attendeesLimitsValue }}
                                components={{
                                    strong: <span className="fs-12px ibl-font-w-700 font-color-secondary-700" />
                                }}
                            />
                        }
                        Icon={InfoChip}
                        showAvatar={true}
                        variant="large"
                        iconPosition={POSITION_MODEL.LEFT}
                        classNameIcon="icon-color-secondary-700"
                        deleteIcon={<CloseIcon fontSize='small' className={`font-color-secondary-700 h-18px`} />}
                    />
                </div>
            }


            <CustomCard classes={"w-100"} classCard={'card-border-8px'}>
                <div className='row'>
                    <div className='col-8 px-0'>
                        <CustomTabContainer
                            activeTab={selectedUserType}
                            setActiveTab={(e) => {
                                setSearchElement("");
                                setResults(prev => ({
                                    ...prev,
                                    content: [],
                                    empty: true,
                                    numberOfElements: 0,
                                    totalElements: 0,
                                    totalPages: 0
                                }));
                                setSelectedUserType(e);
                            }}
                            className="border-0 px-3"
                            paddingClass=''
                        >
                            {TABS_USER_TYPE.map((item) => (
                                <CustomTab
                                    key={item.key}
                                    id={item.key}
                                    title={t(item.translation)}
                                    icon={item.icon}
                                    selected={selectedUserType === item.key}
                                    onClick={() => {
                                        setSelectedUserType(item.key)
                                    }}
                                />
                            ))}
                        </CustomTabContainer>

                        <div className="border-bottom-shades-300 my-3" />

                        <AttendingUsersTable
                            setBodyForExport={setBodyForExport}
                            results={results}
                            setResults={setResults}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            setSearch={setSearch}
                            setSimpleSearch={setSimpleSearch}
                            optionTable={optionTable}
                            userTypeIds={[selectedUserType]}
                            usersSelected={usersSelected}
                            setUsersSelected={setUsersSelected}
                            showCreateNewVisitorModal={showCreateNewVisitorModal}
                            setShowCreateNewVisitorModal={setShowCreateNewVisitorModal}
                            modified={modified}
                            setModified={setModified}
                        />
                    </div>
                    <div className='col-4 pr-0'>
                        <SectionSelected
                            title={"attendees"}
                            count={usersSelected.length}
                        >
                            {usersSelected.length > 0
                                ?
                                <>
                                    {usersSelected?.map((item, index) => (
                                        <div
                                            key={item.id || index}
                                        >
                                            <UserCardDetails
                                                item={item}
                                                setUsersSelected={setUsersSelected}
                                                optionInTable={false}
                                            />
                                        </div>
                                    ))}
                                </>
                                :
                                <NotInformation text={t('no_guests_added_yet')} className={"h-215px"} card={true} />
                            }
                        </SectionSelected>

                    </div>
                </div>

            </CustomCard>
        </>
    );

}

export default AttendeesTypes
